// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

import NestedForm from "@stimulus-components/rails-nested-form";
application.register("nested-form", NestedForm);

import DynamicListController from "./dynamic_list_controller";
application.register("dynamic-list", DynamicListController);

import EventFormController from "./event_form_controller";
application.register("event-form", EventFormController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ImagePreviewController from "./image_preview_controller";
application.register("image-preview", ImagePreviewController);

import MapDisplayController from "./map_display_controller";
application.register("map-display", MapDisplayController);

import MapPickerController from "./map_picker_controller";
application.register("map-picker", MapPickerController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import QuillController from "./quill_controller";
application.register("quill", QuillController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import TagifyController from "./tagify_controller";
application.register("tagify", TagifyController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);
